module.exports = __webpack_public_path__ + "img/sustainabilityPlatinum.2ef7f3b.webp";